import React from "react";
import Dashboard from "../Dashboard/Dashboard";
import MailLogsSection from "../../Sections/MailLogs";

const MailLogsComponent = () => {
    return (
        <Dashboard sectionName={<MailLogsSection />}/>
    );
};

export default MailLogsComponent;
